import React from 'react';


export function Tabs({tabs, activeTab, onTabChange, className = ''}) {
    return (
        <div className={`tw-tabs tw-mb-4 ${className}`}>
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    className={`tw-tab tw-tab-lg tw-tab-bordered ${activeTab === tab.key ? 'tw-tab-active' : ''}`}
                    onClick={() => onTabChange(tab.key)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
}
